export let AdminRole;
(function (AdminRole) {
  AdminRole["SUPER_ADMIN"] = "super_admin";
  AdminRole["GAME_MANAGER"] = "game_manager";
  AdminRole["MEMBER"] = "member";
})(AdminRole || (AdminRole = {}));

export const ADMIN_ROLES = [AdminRole.SUPER_ADMIN, AdminRole.GAME_MANAGER, AdminRole.MEMBER];
